



<div class="container">

  <div class="row">
    <div class="col-md-4">
      <img  class="img-fluid" style="width: 100%;"  [src]="placeImage2">
      <p> Image by NASA Earth API. please wait</p>
    </div>
    <div class="col-md-8 text-left">
      <div class="vertical-center">
        <div class="container">
          <h1> {{ place }}</h1>
          <h3> {{count}} vulnerable person(s)</h3>
        </div>
      
      </div>
     
    </div>
  </div>

  <table class="table table-striped">
    <thead>
      <tr>
        <th scope="col">Name</th>
      <th scope="col">Time Span</th>
        <th scope="col">Control No</th>
        <th scope="col">Medical Condition</th>
      </tr>
    </thead>
    <tbody *ngFor="let traced of data"  >
      <tr >
        <td> {{ traced.name }} </td>
        <td> {{ traced.timein2 }} - {{ traced.timeout2 }}</td>
        <td> {{ traced.controlNo }} </td>
        <td> {{ traced.medicalCondition }} </td>

      </tr>

  </table>



</div>

